module.exports = __webpack_public_path__ + "img/selected2-min.6ee2e547.png";